module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('br')]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "toc_marker-7",
      "title": "Epigraphs"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Martin has used the Negro church as a kind of tool not only to liberate Negroes, but to liberate the entire country. The only people in the country at the moment who even believe in Christianity are the most despised minority in it.")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("AMES")]), _vm._v(" B"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ALDWIN")])]), _vm._v(" "), _c('div', {
    staticClass: "chding"
  }, [_c('img', {
    staticClass: "dingbat",
    attrs: {
      "alt": "epi_breaker",
      "src": "Images/epi_breaker.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("History throws a light on it. We are in a revolutionary situation, and all through history it’s the despised minorities —the proletarians, the peasants, the poor—who recaptured the heights and depths of faith.")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("EINHOLD")]), _vm._v(" N"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("IEBUHR")])]), _vm._v(" "), _c('div', {
    staticClass: "chding"
  }, [_c('img', {
    staticClass: "dingbat",
    attrs: {
      "alt": "epi_breaker",
      "src": "Images/epi_breaker.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("from "), _c('em', [_vm._v("The Meaning of the Birmingham Tragedy,")]), _vm._v(" September 22, 1963")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d094f39a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/epigraphs.vue
// module id = 72
// module chunks = 0